import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=ecee99e6&scoped=true"
import script from "./preference.vue?vue&type=script&lang=js"
export * from "./preference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee99e6",
  null
  
)

export default component.exports